import { Fragment } from 'react';
import { jsx } from 'react/jsx-runtime';
import { useLabels } from '../Labels/hooks/useLabels.js';
import { TextLine } from '../TextLine/TextLine.js';

function HorizontalBarChartXAxisLabels({
  allowLineWrap,
  chartX,
  chartY,
  labels,
  labelWidth,
  onHeightChange,
  ticks,
  xScale
}) {
  const {
    lines
  } = useLabels({
    allowLineWrap,
    labels,
    onHeightChange,
    targetWidth: labelWidth
  });
  return /*#__PURE__*/jsx(Fragment, {
    children: lines.map((line, index) => {
      var _xScale;
      const x = (_xScale = xScale(ticks[index])) !== null && _xScale !== void 0 ? _xScale : 0;
      return /*#__PURE__*/jsx("g", {
        transform: `translate(${chartX + x},${chartY})`,
        children: /*#__PURE__*/jsx(TextLine, {
          line: line,
          index: index
        })
      }, index);
    })
  });
}

export { HorizontalBarChartXAxisLabels };
